import { render, staticRenderFns } from "./InvoicedOrderLogs.vue?vue&type=template&id=505452ca"
import script from "./InvoicedOrderLogs.vue?vue&type=script&lang=js"
export * from "./InvoicedOrderLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports